import { z } from "zod";

export const PAYOUT_NOTE_MAX = 500;

export const createPayoutSchema = z
  .object({
    sessionIds: z.array(z.string().min(1)).optional(),
    /** Upisi u grupne terapije (`group_therapy_enrollments.id`). */
    enrollmentIds: z.array(z.string().min(1)).optional(),
    note: z
      .string()
      .trim()
      .max(PAYOUT_NOTE_MAX, `Napomena ne smije biti duža od ${PAYOUT_NOTE_MAX} znakova.`)
      .nullable()
      .optional(),
  })
  .refine((d) => (d.sessionIds?.length ?? 0) + (d.enrollmentIds?.length ?? 0) > 0, {
    message: "Odaberite bar jednu seansu za isplatu.",
    path: ["sessionIds"],
  });
